import { adminWorkspaceDeveloperQueryKeys as e } from "./useAdminWorkspaceDeveloperQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminWorkspaceDeveloperApi as r } from "@maat/api-main";
//#region src/workspaceDeveloper/useSetDeveloperKeyRateLimitMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ workspaceId: e, keyId: t, ...n }) => r.setKeyRateLimit(e, t, n),
		onSuccess: (t, { workspaceId: n }) => {
			i.invalidateQueries({ queryKey: e.keys(n) });
		}
	});
};
//#endregion
export { i as useSetDeveloperKeyRateLimitMutation };
